var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10278",
    "data-name": "Group 10278",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.462,
    height: 22.462,
    viewBox: "0 0 22.462 22.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2335",
    "data-name": "Rectangle 2335",
    width: 22.462,
    height: 22.462,
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10277",
    "data-name": "Group 10277",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27599",
    "data-name": "Path 27599",
    d: "M15.822,10.743a6.348,6.348,0,1,0-9.181,0A11.277,11.277,0,0,0,0,21a1.44,1.44,0,0,0,1.465,1.465H21A1.44,1.44,0,0,0,22.462,21a11.277,11.277,0,0,0-6.64-10.254M7.813,6.348a3.418,3.418,0,1,1,3.418,3.418A3.4,3.4,0,0,1,7.813,6.348M3.078,19.532a8.28,8.28,0,0,1,16.307,0Z",
    fill: "#152c40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.03e0a7f3c0c537dc377104d0b4979aae.svg";
export { ForwardRef as ReactComponent };